module.exports = __webpack_public_path__ + "img/icon-topic-heart.b13271e2.svg";